import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-parent-home',
  templateUrl: './parent-home.component.html',
  styleUrls: ['./parent-home.component.scss']
})
export class ParentHomeComponent implements OnInit {
  showChild = false;
  studentData: any;
  dashboardData = [];
  parentHomeLoader = false;
  noData: boolean;
  currentPageId;
  selectedParentData: {};
  isParentRegistered = true;
  module : string;
  partnerName: string;

  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private _commonService: CommonService,
    private _routes: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit() {
    this.getParentDashboardData();
    const localStorageData = localStorage.getItem('loginUserData');
    this.module = JSON.parse(localStorageData).module
    const partnerDetail = JSON.parse(localStorage.getItem('partnerDetail'));
   this.partnerName = partnerDetail.partnerName;
  }

  getParentDashboardData() {
    const inputObject = {};

    const selectedParentData = this._commonService.getDataWithoutObservable('selectedParentDataFromCoach');
    this.selectedParentData = selectedParentData;
    if (selectedParentData) {
      inputObject['parentProfileId'] = selectedParentData.profileId ? selectedParentData.profileId : selectedParentData.id;
    }
    this.parentHomeLoader = true;
    this._commonRequestResponseService.postWithHeader('parent/dashboard/', inputObject)
      .subscribe(
        (dashboardData: any) => {
          if (dashboardData && dashboardData.students) {
            this.dashboardData = dashboardData.students;
            this.noData = false;
          } else {
            this.noData = true;
          }
          this.parentHomeLoader = false;
          this.isParentRegistered = dashboardData.isRegistered;
        },
        () => {
          this.parentHomeLoader = false;
          this.notificationService.show('error', 'Error while fetching product data');
        });
  }

  resendWelcomeEmail() {
    const userJson = {
      userId: this.selectedParentData['userId'] ? this.selectedParentData['userId'] : this.selectedParentData['id']
    };
    this._commonRequestResponseService.postWithHeader('admin/welcomeemail/send', userJson)
      .subscribe(
        () => {
          this.notificationService.show('success', 'Welcome Email Send successfully');
        },
        () => {
          this.notificationService.show('error', 'Error while Welcome Email Send successfully');
        });
  }

  parentClicked(item: any) {
    localStorage.setItem('parentStudentId', JSON.stringify(item.studentUserId));
    this.showChild = !this.showChild;
   
    setTimeout(() => {
      this.commonDataSharedService.parentHomeData.next(item);
      localStorage.setItem('parentChildLocalData', JSON.stringify(item));
      this._router.navigate(['../studentSummary'], { relativeTo: this._routes });
    }, 500)
  }

  back() {
    this.showChild = false;
  }
}
